export default __webpack_public_path__ + "static/media/devproductivity.16276a8b.jpg";